import { AddColorHeader } from "./TrayPlacementTools.js"
import { GiftClickHandler } from "./TrayItemsClickedActions/GiftClickHandler.js"

export function GiftTab(Scene,Tray)
{
    AddColorHeader(Scene, Tray);

    const PresentArray = [];
    const WhtGiftCover = [];
    //const DepthList = CreateDepth();
    const DisplayPlacementOrg =
    [
        [181.32421304166988,180.33875815825243],
        [295.19931848427365,180.33875815825246],
        [182.419165978618,279.97947325287095],
        [290.8195067364812,281.0744261659986],
        [234.9769069521274,351.15141260616974],
        [179.13430716777364,417.9435403069579],
        [286.43969498868876,410.2788699150642],
        [300.67408316901424,455.1719393532989],
        [229.50214226738686,492.40033839963985],
        [176.94440129387746,584.3763831023645],
        [272.2053068083633,588.7561947548752],
        [172.56458954608496,708.1060622857917],
        [271.1103538714151,668.6877574131954],
        [269.11035387141516,727.8152147220899]
    ];

    const DisplayPlacement = DisplayPlacementOrg.map(value=>
        {value[0] -= 210
            return value;
        });

    //console.log(DisplayPlacement);

    for (let x = 0; x < 14; x++)
    {
        WhtGiftCover[x] = Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"WtGft"+(x+1)+"_Strk").setAlpha(0);
        WhtGiftCover[x].setTint(0xD3CFE8);
        PresentArray[x] = Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"Gft"+(x+1));
        Scene.ColorGroup.add(PresentArray[x]);
        if(x != 8)
        {
            PresentArray[x].setInteractive();
        }
        else
        {
            PresentArray[x].setInteractive(Scene.input.makePixelPerfect());
            WhtGiftCover[x].x += 4;
        }   
        PresentArray[x].on('pointerdown',function(Pointer){

            GiftClickHandler(this,Pointer);

        });
        
        // PresentArray[x] = Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"WtGft"+(x+1)+"_BG");
        //PresentArray[x] = Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"WtGft"+(x+1)+"_Strk");
    }

    // for (let x = 0; x < 14; x++)
    // {
    //     Tray.setTint(0x000000);
    //     PresentArray[x] = Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"WtGft"+(x+1)+"_BG");
    //     Scene.addImage(DisplayPlacement[x][0],DisplayPlacement[x][1],"WtGft"+(x+1)+"_Strk");
    //     Scene.ColorGroup.add(PresentArray[x]);
    //     PresentArray[x].on('drop',()=>{
    //         //console.log("On tree");
    //     });
    //     PresentArray[x].on('dragenter',()=>{
    //         //console.log("Enter the tree");
    //     });
    // }

    Scene.TrayGroup.addMultiple(PresentArray);
    Scene.TrayGroup.addMultiple(WhtGiftCover);
    Scene.GiftGroup.addMultiple(WhtGiftCover);

    Scene.ColorGroup.getChildren().forEach(element =>
        {
            element.setTint(0xF70D0D);
        });
    //Scene.TrayGroup.clear(true,true);
}